import { render, staticRenderFns } from "./SubsituteDetails.vue?vue&type=template&id=30ac8566&scoped=true&"
import script from "./SubsituteDetails.vue?vue&type=script&lang=js&"
export * from "./SubsituteDetails.vue?vue&type=script&lang=js&"
import style0 from "./SubsituteDetails.vue?vue&type=style&index=0&id=30ac8566&lang=less&scoped=true&"
import style1 from "./SubsituteDetails.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ac8566",
  null
  
)

export default component.exports